// NPM Imports
import React from "react";

// Internal Imports
import NO_QUOTES from "../../../assets/quotes_empty_state.png";
import { COMMON } from "../../../constants";

// Destructuring
const { DEAL_LABELS } = COMMON;

function DealTableEmptyScreen(props) {
  function _decideScreen() {
    // Spl Case : If document has QuoteTable attached
    if (props.isQuoteTable) {
      return (
        <span
          data-test="dealtablegrid-noitems-crmconfigured-quotetable-msg"
          className="dealtablegrid-noitems-msg">
          There are no items in this quote. Since you have retrieved this quote
          from a source CRM, add quote line items in the source quote and sync
          again.
        </span>
      );
    }
    // Case : DealTable Type other than draft stage opened other than the doc owner
    if (props.isLocked && !props.isDocumentOwner) {
      return (
        <span
          data-test="dealtablegrid-noitems-choosepricebook-msg"
          className="dealtablegrid-noitems-msg">
          The deal table is empty. Only the document owner can add items from
          the product catalog.
        </span>
      );
    }
    // Case : DealTable Type other than draft stage
    if (props.isLocked) {
      return (
        <span
          data-test="dealtablegrid-noitems-movetodraftstage-msg"
          className="dealtablegrid-noitems-msg">
          No items added to the Deal Table. Please move the document to draft to
          add products.
        </span>
      );
    }
    // Case : DealTable Type Draft stage without pricebook selection
    if (props.isEmptyTable) {
      return (
        <span
          data-test="dealtablegrid-noitems-choosepricebook-msg"
          className="dealtablegrid-noitems-msg">
          No items added to the {DEAL_LABELS["deal-table-label"]}. Please choose
          from the Price Book.
          <span role="img" aria-label="Hand" className="hand">
            👉
          </span>
        </span>
      );
    }
    // Case : DealTable Type Draft stage with pricebook selected
    return (
      <span
        data-test="dealtablegrid-noitems-msg"
        className="dealtablegrid-noitems-msg">
        No items added to the {DEAL_LABELS["deal-table-label"]}. Please choose
        from the Catalog.
        <span role="img" aria-label="Hand" className="hand">
          👉
        </span>
      </span>
    );
  }
  return (
    <div className="dealtablegrid-noitems-container">
      <img
        src={NO_QUOTES}
        data-test="dealtablegrid-noitems-img"
        className="dealtablegrid-noitems-img"
        alt="no quotes"
      />
      {_decideScreen()}
    </div>
  );
}

export default DealTableEmptyScreen;



// WEBPACK FOOTER //
// ./src/components/DealTable/DealTableEmptyScreen/index.js